"use client";

// FOUNDER-WALK-QA-STAGING-007 · A4 — WHY THIS DIRECTIVE IS HERE.
// client-boundary-gate flagged this module RED: "server module calls into a client module", for
// `import type { CartItem } from "@/lib/cart-store"`. The import is type-only and erases at
// compile time, so the finding costs nothing at runtime — but the gate grades the MODULE GRAPH,
// not the emitted bundle, and it is right to: a module with no directive is a server module that
// today happens to be imported only by client components, and the next importer decides otherwise.
// This module is browser-only by construction (it reads `window.location`, and POSTs a relative
// URL), so the directive states what was already true rather than changing what it does.

// SNOWCLUB-V101-STAGING-A1 · WHAT IS LEFT HERE, AND WHY THE REST IS GONE.
//
// This module used to hold `resolvePayResult`: the answer to the design's `sg:pay`, which POSTed the
// legacy booking engine (`/api/legacy/booking/submit`) and, on the staging host, painted
// `booked: true, orderId: "PREVIEW — NOT A REAL BOOKING"` — a confirmation screen with no order, no
// server price and no payment behind it. The A1 packet forbids that legacy fallback, so the answerer is
// removed rather than left unused: `@/lib/design-pay` (`resolveDesignPay`) is now the only answer, and it
// creates a server-priced order and hands the card to Stripe's hosted PaymentElement on the checkout app.
//
// What stays is shared vocabulary: the `sg:pay` / `sg:payresult` shapes, the depart-line predicate the
// checkout's cart mapping uses, and the preview-host allow-list `tooling/port-harness/preview-host.mjs`
// keeps a parity copy of.

import type { CartItem } from "@/lib/cart-store";

export type PayResult = {
  booked: boolean;
  orderId?: string;
  paid?: string;
  items?: number;
  reason?: string;
};

/** The `order` half of the export's `sg:pay` message. */
export type PayOrder = {
  account?: Record<string, string>;
  tip?: number;
  /** §21 — what the customer ticked in the export's own booking-store grid */
  store?: { id?: string; quantity?: number; fromDate?: string; toDate?: string; time?: string }[];
};

export const isDepartLine = (i: CartItem) => /^BUS SEAT \(Departure\)$/.test(i.title);

/** Local development hosts. Kept for the parity check in tooling/port-harness/preview-host.mjs. */
export function isPreviewHost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h.endsWith(".local") || h.endsWith(".localhost");
}
